import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Grid, Typography } from '@material-ui/core'
import theme from 'material/theme'

import { useAppSelector } from 'store'

export function percentFormat(num?: number) {
  if (num === undefined || num === null) {
    return '—'
  }
  if (num === 0) {
    return '0%' // NOTE: Shouldn't happen based on usage, but just in case.
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(num)
}

const DataPoint = ({
  title,
  data,
  isPremium = false,
}: {
  title: string
  data?: string | number
  isPremium?: boolean
}) => {
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )

  return (
    <Box>
      <Box
        display="flex"
        gridGap={4}
        alignItems="center"
      >
        <Typography
          variant="caption"
          component="h3"
          color="textSecondary"
        >
          {title}
        </Typography>
      </Box>
      {isPremium && !isPremiumExplorerEnabled ? (
        <FontAwesomeIcon
          icon={faLock}
          color={theme.palette.text.disabled}
        />
      ) : (
        <Typography>{data ? data : '—'}</Typography>
      )}
    </Box>
  )
}

type DataPointsGridProps = {
  dataPoints: {
    title: string
    data?: string | number
    isPremium?: boolean
  }[]
}
const DataPointsGrid = ({ dataPoints }: DataPointsGridProps) => {
  return (
    <Grid
      container
      spacing={2}
    >
      {dataPoints.map((dataPoint) => (
        <Grid
          item
          xs={6}
          key={dataPoint.title}
        >
          <DataPoint
            title={dataPoint.title}
            data={dataPoint.data}
            isPremium={dataPoint.isPremium}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default DataPointsGrid
